export default "__VITE_ASSET__CgXrUm4p__"